module["exports"] = [
  "Nepal"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nep/address/default_country.js
 ** module id = 786
 ** module chunks = 0
 **/